import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { ConnectionsPage } from "@/modules/linkops/ConnectionsPage";
import { DebugPage } from "@/modules/linkops/DebugPage";
import { StatisticsPage } from "@/modules/linkops/StatisticsPage";

export function LinkModule() {
  return (
    <>
      <SubNav
        base="/link"
        tabs={[
          { path: "connections", label: "Connections" },
          { path: "statistics", label: "Statistics" },
          { path: "debug", label: "Debug Test" },
        ]}
      />
      <Routes>
        <Route path="connections" element={<ConnectionsPage />} />
        <Route path="statistics" element={<StatisticsPage />} />
        <Route path="debug" element={<DebugPage />} />
        <Route path="*" element={<Navigate to="connections" replace />} />
      </Routes>
    </>
  );
}
